import React, { Component } from 'react';
import { connect } from 'react-redux';
import { switchStoneType } from '../../appRedux/actions/Common';
import { Select } from 'antd';
import _ from 'lodash';

const { Option } = Select;

class StoneTypeDropdown extends Component {
    state = {
        defaultVal: this.props.commonData.labGrown,
    };

    render() {
        return (
            <Select
                className="formSelect from-group dropdownLag"
                defaultValue={this.state.defaultVal}
                style={{ width: 200, display: (this.props.commonData.showNatural && this.props.commonData.showLabGrown) ? "block" : "none" }}
                onChange={this.props.switchStoneType}
            >
                <Option key={'N'}>
                    Natural Diamonds
                </Option>
                <Option key={'Y'}>
                    Lab-Grown Diamonds
                </Option>
            </Select>
        );
    }
}

const mapStateToProps = (props) => props;
export default connect(mapStateToProps, { switchStoneType })(StoneTypeDropdown);
